import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import fr from "./locales/fr.json";
import en from "./locales/en.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { fr: { translation: fr }, en: { translation: en } },
    fallbackLng: "fr",
    supportedLngs: ["fr", "en"],
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "ariovis_lang",
    },
    interpolation: { escapeValue: false },
  });

// keep <html lang> in sync
const setHtmlLang = (lng) => {
  try { document.documentElement.setAttribute("lang", lng); } catch (e) { /* noop */ }
  try {
    const title = i18n.t("meta.title");
    if (title) document.title = title;
    const desc = i18n.t("meta.description");
    const m = document.querySelector('meta[name="description"]');
    if (m && desc) m.setAttribute("content", desc);
  } catch (e) { /* noop */ }
};
setHtmlLang(i18n.language);
i18n.on("languageChanged", setHtmlLang);

export default i18n;
